import { render, staticRenderFns } from "./AudienceManage.vue?vue&type=template&id=6c420987"
import script from "./AudienceManage.vue?vue&type=script&lang=js"
export * from "./AudienceManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports